<template>

    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-col items-center">
          <div class="w-full max-w-lg" id="noticeModalForm" @submit.prevent>
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold">Crear nuevo levantamiento</div>
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="title"
                >¿Desea crear un nuevo levantamiento? Esto borrará las geometrías actualmente dibujadas</label>
<!--                 <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="title"
                  name="title"
                  type="text"
                  v-model="title"
                />
                <p
                  v-if="errors.title"
                  class="text-red-500 text-xs italic text-left"
                >Escriba un título</p> -->
              </div>
            </div>


            <div class="flex w-full justify-end">
              <button
                class="bg-secondary-color hover:bg-secondary-color-dark px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                @click="crearNuevo()"
              >Aceptar</button>
              <button
                class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                @click="close()"
              >Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { backend_url } from "../config/url.config.ts";

//import polygon from "../assets/polygonChapp.json";

/* import { LMap, LGeoJson } from "vue2-leaflet";
import LDraw from "leaflet-draw";
import * as esri from "esri-leaflet";

import drawLocales from "leaflet-draw-locales"; */

export default {
  name: "notice-modal",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      options: [
        { text: "Hombre", value: "H" },
        { text: "Mujer", value: "M" }
      ],
      errors: {
        title: false,
        description: false,
      },
      maxBounds: [
        [19.395295944890695, -99.22922388422747],
        [19.43212847837641, -99.17403475153704]
      ],
      //polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      noticeArea: null,
      leafletMap: null,
      currentNoticeArea: null,
      controlAdd: null,
      controlEdit: null
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    geometries: {
      required: true
    }    
  },
  components: {
/*     LMap,
    LGeoJson */
  },
  watch: {
    showing(value) {
/*       if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden"); */
    },
  },
  methods: {
    reset() {
      this.category = null;
      this.description = "";
      this.title = "";
    },
    close() {
      //this.reset();
      this.$emit("close");
    },

    crearNuevo(){
      this.$emit("createNew");
      this.$emit("close");
    },

  },
  mounted() {

  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>
